var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var getObjectType = function (obj) { return Object.prototype.toString.call(obj); };
var isFunction = function (obj) { return getObjectType(obj) === '[object Function]'; };
var isPureObject = function (obj) { return getObjectType(obj) === '[object Object]'; };
var isEmpty = function (val) { return val === null || val === undefined || val === ''; };
var checkIsPrintableKey = function (e) {
    if (e.ctrlKey || e.metaKey)
        return false;
    var keycode = e.keyCode || e.which;
    if ((keycode > 47 && keycode < 58) || // number keys
        keycode === 32 ||
        keycode === 13 || // space & return key(s) (if you want to allow carriage returns)
        (keycode > 64 && keycode < 91) || // letter keys
        (keycode > 95 && keycode < 112) || // numpad keys
        (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
        (keycode > 218 && keycode < 223) // [\]' (in order)
    ) {
        return true;
    }
};
var judgeKey = function (e, key, keyCode) {
    return e.key === key || e.keyCode === keyCode || e.which === keyCode;
};
var isBackSpace = function (e) { return judgeKey(e, 'Backspace', 8); };
var warpCommand = function (adapter, command) { return function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return command.apply(null, __spreadArray([adapter], args, true));
}; };
var detachedDocument = null;
var createDetachedElement = function (tagName) {
    if (!detachedDocument)
        detachedDocument = document.implementation.createHTMLDocument('detach');
    return detachedDocument.createElement(tagName);
};
var formatToDOMAttrs = function (attrs) {
    var result = {};
    Object.keys(attrs).forEach(function (key) {
        var value = attrs[key];
        if (isEmpty(value))
            return;
        if (value instanceof Object)
            result[key] = JSON.stringify(value);
        else
            result[key] = value;
    });
    return result;
};
var toArray = function (arg) {
    if (arg instanceof Array)
        return arg;
    return [arg];
};
var groupData = function (target, key, handler, prioritized) {
    if (!Array.isArray(target[key]))
        target[key] = [];
    target[key][prioritized ? 'unshift' : 'push'](handler);
};
var filterData = function (target, key, handler) {
    if (!Array.isArray(target[key]))
        return;
    target[key] = target[key].filter(function (fn) { return fn !== handler; });
};
export { checkIsPrintableKey, createDetachedElement, filterData, formatToDOMAttrs, getObjectType, groupData, isBackSpace, isFunction, isPureObject, judgeKey, toArray, warpCommand, };
//# sourceMappingURL=utils.js.map